__webpack_require__.p = "https://static.age.awaze.com/search-mfe/22b4af4/_next/";